import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import { Stack } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectTileFields } from "../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import { isCustomColumn, isDimensionBased, isMeasure } from "../../../../utilities/fieldsHelper.ts";
import DimensionFormattingContainer from "../../common/fields/format/DimensionFormattingContainer";
import { canApplyFormat } from "../../common/fields/format/dimensionFormattingHelper";
import MeasureFieldsContainer from "../../common/fields/format/MeasureFieldsContainer";

const FormatContainer = ({ readonlyMode }: { readonlyMode: boolean }) => {
  const dispatch = useAppDispatch();
  const fieldsAreaValues = useSelector(selectTileFields);

  const supportingFormattingMeasures = useMemo(
    () => fieldsAreaValues.filter((f) => isMeasure(f) || isCustomColumn(f)),
    [fieldsAreaValues]
  );
  const dimensions = useMemo(() => fieldsAreaValues.filter(isDimensionBased), [fieldsAreaValues]);
  const supportingFormattingDimensions = useMemo(() => dimensions.filter(canApplyFormat), [dimensions]);

  const handleFieldFormattingChange = useCallback(
    (reportField: ReportField, changes: Partial<FieldConfiguration>) => {
      const field = fieldsAreaValues.find((f) => f.config.guid === reportField.config.guid);
      if (isDimensionBased(field) || isMeasure(field) || isCustomColumn(field)) {
        dispatch(fieldsStateActions.updateFieldConfig({ field, changes }));
      }
    },
    [dispatch, fieldsAreaValues]
  );
  return (
    <ScrollableFlexContainer scrollContainerSx={{ px: "1.3rem" }}>
      <Stack sx={{ gap: 1 }}>
        <DimensionFormattingContainer
          dimensions={supportingFormattingDimensions}
          onUpdateConfig={handleFieldFormattingChange}
          readonlyMode={readonlyMode}
        />
        <MeasureFieldsContainer
          measures={supportingFormattingMeasures}
          onChange={handleFieldFormattingChange}
          readonlyMode={readonlyMode}
        />
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default FormatContainer;
